import fromAmountSelectorDefinition from './from-amount.js';
import fromAssetSelectorDefinition from './from-asset.js';
import prefillOptionIdSelectorDefinition from './prefill-option-id.js';
import remoteWarningSelectorDefinition from './remote-warning.js';
import slippageSelectorDefinition from './slippage.js';
import toAmountSelectorDefinition from './to-amount.js';
import toAssetSelectorDefinition from './to-asset.js';
import availabilitySelectorDefinition from './availability.js';
import exchangeableAssetsSelectors from './exchangeable-assets.js';
const exchangeSelectors = [
    availabilitySelectorDefinition,
    fromAmountSelectorDefinition,
    fromAssetSelectorDefinition,
    prefillOptionIdSelectorDefinition,
    remoteWarningSelectorDefinition,
    slippageSelectorDefinition,
    toAmountSelectorDefinition,
    toAssetSelectorDefinition,
    ...exchangeableAssetsSelectors,
];
export default exchangeSelectors;
